var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M22,14 v-0.983c0-0.71-0.372-1.363-0.983-1.725C20.044,10.717,18.358,10,16,10c-2.388,0-4.064,0.713-5.026,1.288 C10.368,11.65,10,12.301,10,13.007V14H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M13,31v-0.983 c0-0.71-0.372-1.363-0.983-1.725C11.044,27.717,9.358,27,7,27c-2.388,0-4.064,0.713-5.026,1.288C1.368,28.65,1,29.301,1,30.007V31 H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M31,31v-0.983 c0-0.71-0.372-1.363-0.983-1.725C29.044,27.717,27.358,27,25,27c-2.388,0-4.064,0.713-5.026,1.288C19.368,28.65,19,29.301,19,30.007 V31H31z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: 10,
    cx: 16,
    cy: 4,
    r: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.5335c238147f9126505eec8777e7848d.svg";
export { ForwardRef as ReactComponent };